import { formatMoney } from 'accounting'
import { DateTime } from 'luxon'

import { DashboardModuleListItem } from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import type { CampaignQuoteTemplateModel } from '@models/types'

import { generateUrls } from '@hooks/useCampaignQuoteTemplate'

interface CampaignQuoteTemplateListItemProps {
  campaignQuoteTemplate: CampaignQuoteTemplateModel,
}

const CampaignQuoteTemplate = (props: CampaignQuoteTemplateListItemProps) => {
  const {
    campaignQuoteTemplate,
    campaignQuoteTemplate: {
      agency_id,
      title,
      total,
    },
  } = props

  const { editCampaignQuoteTemplateUrl } = generateUrls(campaignQuoteTemplate, {
    prefixRoute: `agencies/${agency_id}/manage`,
  })

  const createdDateString = digObject(campaignQuoteTemplate, 'dates.created.date_time')

  return (
    <DashboardModuleListItem
      href={editCampaignQuoteTemplateUrl}
      secondaryText={
        createdDateString
          ? DateTime.fromFormat(createdDateString, 'dd/MM/yyyy HH:mm').toFormat("'Created' ccc dd LLL yyyy 'at' h:mm a")
          : 'Not Set'
      }
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>{formatMoney(total)}</DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default CampaignQuoteTemplate
